import { FC } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import styles from './styles/PdpSharedRingSizeGuideModalLink.scss';

const messages = defineMessages({
    sizeGuide: {
        id: 'pdp.ringSizeGuide',
        defaultMessage: 'Size Guide',
    },
});

type Props = { onClick: () => void };

export const PdpSharedRingSizeGuideModalLink: FC<Props> = ({ onClick }) => {
    const intl = useIntl();
    return (
        <Link className={styles.link} onClick={onClick}>
            ({intl.formatMessage(messages.sizeGuide)})
        </Link>
    );
};
